// extracted by mini-css-extract-plugin
export default {"header":"viewAll_header__5NAid","title":"viewAll_title__+Mibg"};